module.exports = "<p translate>Info.SubsurfaceRights</p>"